module.exports = "#fullformWrapper{width:100%;min-height:100vh;height:100%;padding:50px 0px}\n"